import React from "react";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { Link } from "react-router-dom";
import CardHeader from "components/Card/CardHeader.jsx";

const Avatar = props => {
  let { uri, id } = props;

  if (uri == null) {
    return (
              <CardHeader image>
              <a href="#" onClick={e => e.preventDefault()}>

              </a>
              <div
                //className={classes.coloredShadow}
                style={{
                //  backgroundImage: `url(${uri})`,
                opacity: "1"
                }}
              ><PersonAddIcon style={{ fontSize: 40 }} /></div>
            </CardHeader>
          )
  } else {
    return (
              <CardHeader image>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={uri} alt="..." />
              </a>
              <div
                //className={classes.coloredShadow}
                style={{
                  backgroundImage: `url(${uri})`,
                  opacity: "1"
                }}
              />
            </CardHeader>
          )
  }
};

export default Avatar;
